import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DashboardLayout from "../common/DashboardApp";
import Loader from "../common/Loader";
import { getTaskData, uploadTask } from "../../../service/employerapi";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const TaskList = () => {
  const { applicationId } = useParams();
  const [taskData, setTaskData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTask, setSelectedTask] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [btnloading, setBtnLoading] = useState(false);

  const [isViewOnly, setIsViewOnly] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const data = await getTaskData(applicationId);
        setTaskData(data?.data || []);
        setProgress(data?.data.progressPercent);
      } catch (error) {
        console.error("Error fetching tasks:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTasks();
  }, [applicationId]);

  const handleUploadTask = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const submittedTaskId = formData.get("taskId");
    const status = formData.get("employerApprovedTask");

    try {
      setBtnLoading(true);
      const response = await uploadTask(formData);
      toast.success(response.data.message || "Task updated successfully!");

      // ✅ Update UI instantly
      setTaskData((prev) =>
        prev.map((t) =>
          t.taskId === submittedTaskId
            ? { ...t, employerApprovedTask: status }
            : t
        )
      );

      setShowModal(false);
    } catch (error) {
      console.error("Error uploading task:", error);
      toast.error(error.response?.data?.message || "Failed to update task.");
    } finally {
      setBtnLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <DashboardLayout>
      <div className="panelMainWrapper">
        <div className="titlSectionu userpaneltitle text-left position-relative">
          <h2>Task List</h2>
        </div>

        {taskData.length === 0 ? (
          <div className="alert alert-info text-center">No task found.</div>
        ) : (
          <table className="table mt-4 hj-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Title</th>
                <th>Description</th>
                <th>Hours Worked</th>
                <th>Progress</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {taskData.map((task, index) => (
                <tr key={task.id || index}>
                  <td>{index + 1}</td>
                  <td>{task.title}</td>
                  <td>
                    {task.description?.length > 70
                      ? task.description.substring(0, 70) + "..."
                      : task.description}
                  </td>
                  <td>{task.hoursWorked}</td>
                  <td>{task.progressPercent}%</td>
                  <td>
                    <span
                      style={{
                        backgroundColor:
                          task.employerApprovedTask === "Approved"
                            ? "#00e721"
                            : task.employerApprovedTask === "Rejected"
                            ? "#e71b00"
                            : task.employerApprovedTask === "Modified"
                            ? "#00a9e7"
                            : "#e7b100",
                        padding: "2px 12px",
                        borderRadius: "15px",
                        color: "#fff",
                      }}
                    >
                      {task.employerApprovedTask || "Pending"}
                    </span>
                  </td>
                  <td>
                    {!task.employerApprovedTask ||
                    task.employerApprovedTask === "Pending" ? (
                      <div className="d-flex gap-2">
                        {/* ✅ Reject */}
                        <form
                          id={`rejectForm-${task.taskId}`}
                          onSubmit={handleUploadTask}
                        >
                          <input
                            type="hidden"
                            name="taskId"
                            defaultValue={task.taskId}
                          />
                          <input
                            type="hidden"
                            name="employerApprovedTask"
                            defaultValue="Rejected"
                          />
                        </form>

                        <button
                          type="button"
                          className="mainbtn"
                          style={{
                            border: "1px solid #eb2d2dff",
                            backgroundColor: "#eb2d2dff",
                          }}
                          onClick={() => {
                            Swal.fire({
                              title: "Are you sure?",
                              text: "This task will be marked as Rejected!",
                              icon: "warning",
                              showCancelButton: true,
                              confirmButtonColor: "#eb2d2dff",
                              cancelButtonColor: "#6c757d",
                              confirmButtonText: "Yes, Reject",
                              cancelButtonText: "Cancel",
                            }).then((result) => {
                              if (result.isConfirmed) {
                                document
                                  .getElementById(`rejectForm-${task.taskId}`)
                                  .requestSubmit();
                              }
                            });
                          }}
                        >
                          Reject
                        </button>

                        {/* ✅ Approve opens modal */}
                        <button
                          className="mainbtn"
                          style={{
                            border: "1px solid #270b79",
                            backgroundColor: "#270b79",
                          }}
                          onClick={() => {
                            setSelectedTask(task);
                            setIsViewOnly(false);
                            setShowModal(true);
                          }}
                        >
                          Approve
                        </button>
                      </div>
                    ) : (
                      <button
                        className="mainbtn"
                        style={{
                          border: "1px solid #270b79",
                          backgroundColor: "#270b79",
                        }}
                        onClick={() => {
                          setSelectedTask(task);
                          setIsViewOnly(true);
                          setShowModal(true);
                        }}
                      >
                        View Task
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* -------- Modal -------- */}
        {showModal && selectedTask && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            tabIndex="-1"
            onClick={(e) => {
              if (e.target.classList.contains("modal")) setShowModal(false);
            }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Task Details</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>

                <form onSubmit={handleUploadTask}>
                  <div className="modal-body">
                    <input
                      type="hidden"
                      name="taskId"
                      defaultValue={selectedTask.taskId}
                    />
                    <input
                      type="hidden"
                      name="employerApprovedTask"
                      defaultValue="Approved"
                    />

                    <p>
                      <strong>Title:</strong> {selectedTask.title}
                    </p>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <strong>Hours Worked:</strong>{" "}
                          {selectedTask.hoursWorked}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <strong>Progress:</strong>{" "}
                          {selectedTask.progressPercent}%
                        </p>
                      </div>
                    </div>

                    {selectedTask.fileUrl && (
                      <a
                        href={selectedTask.fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-1"
                        style={{
                          border: "1px solid #eb642d",
                          padding: "6px 20px",
                          borderRadius: "10px",
                          color: "#eb642d",
                          textDecoration: "none",
                          width: "100%",
                          display: "inline-block",
                        }}
                      >
                        View File
                      </a>
                    )}

                    <div className="mb-3 mt-3">
                      <label>
                        <strong>Edit Remarks:</strong>
                      </label>
                      <textarea
                        className="form-control"
                        name="remarks"
                        defaultValue={selectedTask.description}
                        disabled={isViewOnly}
                        rows={6}
                      ></textarea>
                    </div>
                  </div>

                  <div className="modal-footer">
                    {!isViewOnly && (
                      <button type="submit" className="normalbtn">
                        {btnloading ? (
                          <span>
                            <i
                              className="fa fa-spinner fa-spin"
                              style={{ marginRight: "8px" }}
                            ></i>
                            Approving...
                          </span>
                        ) : (
                          "Approve"
                        )}
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default TaskList;
